const $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9 = {
    taskForm: document.querySelector("#taskForm"),
    taskInput: document.querySelector("#taskInput"),
    taskList: document.querySelector("#taskList"),
    searchInput: document.querySelector("#searchInput"),
    sortToggle: document.querySelector("#sortToggle"),
    sortLabel: document.querySelector("#sortLabel"),
    sortMenu: document.querySelector("#sortMenu"),
    themeToggle: document.querySelector("#themeToggle"),
    colorOptions: document.querySelectorAll(".color-option"),
    greeting: document.querySelector("#greeting"),
    taskSummary: document.querySelector("#taskSummary"),
    statTotal: document.querySelector("#stat-total"),
    statOpen: document.querySelector("#stat-open"),
    statDone: document.querySelector("#stat-done"),
    personalProgress: document.querySelector("#personalProgress"),
    quoteText: document.querySelector("#quoteText"),
    quoteAuthor: document.querySelector("#quoteAuthor"),
    exportBtn: document.querySelector("#exportBtn"),
    importBtn: document.querySelector("#importBtn"),
    importFileInput: document.querySelector("#importFile"),
    toasts: document.querySelector("#toasts"),
    shareQuoteBtn: document.querySelector("#shareQuoteBtn"),
    copyQuoteBtn: document.querySelector("#copyQuoteBtn"),
    copyQuoteBtnText: document.querySelector("#copyQuoteBtn span"),
    shareModal: document.querySelector("#shareModal"),
    overlay: document.querySelector("#overlay"),
    ogDescriptionMeta: document.querySelector('meta[property="og:description"]'),
    dot: document.querySelector(".cursor-dot"),
    taskTemplate: document.querySelector("#taskTemplate"),
    closeShareModalBtn: document.querySelector("#closeShareModal"),
    shareQuoteBtns: document.querySelectorAll(".share-quote-btn")
};
const $e5ffa7f57df22aad$export$bab7694f6b43412b = $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9.ogDescriptionMeta?.getAttribute("content") ?? "";


const $45af14c00f07ca1e$export$86880b4b2e1a2384 = "todo-ebx-state";
const $45af14c00f07ca1e$export$daa7e859aba5ce88 = "todo-ebx-theme";
const $45af14c00f07ca1e$export$e3ade8805ed84548 = "todo-ebx-color";
const $45af14c00f07ca1e$export$aeee6467aa99f8c2 = "todo-ebx-quote";
const $45af14c00f07ca1e$export$689f758a17cbcc4b = "https://quotesapi.prayushadhikari.com.np/api/quotes?category=inspiration-quotes&limit=1";


const $bf7fb22aa59e9c16$export$49d5fc8cba920a0 = {
    tasks: [
        {
            id: crypto.randomUUID(),
            title: "Gym workout",
            completed: false,
            createdAt: Date.now() - 21600000,
            updatedAt: Date.now() - 21600000
        },
        {
            id: crypto.randomUUID(),
            title: "New UI improvement",
            completed: false,
            createdAt: Date.now() - 7200000,
            updatedAt: Date.now() - 7200000
        }
    ],
    filter: "all",
    search: "",
    sort: "created-desc"
};


function $fe3908612a21a758$export$ea32cbdd559da174() {
    const raw = localStorage.getItem((0, $45af14c00f07ca1e$export$86880b4b2e1a2384));
    if (!raw) return structuredClone((0, $bf7fb22aa59e9c16$export$49d5fc8cba920a0));
    try {
        const parsed = JSON.parse(raw);
        return {
            ...structuredClone((0, $bf7fb22aa59e9c16$export$49d5fc8cba920a0)),
            ...parsed,
            tasks: Array.isArray(parsed.tasks) ? parsed.tasks : structuredClone((0, $bf7fb22aa59e9c16$export$49d5fc8cba920a0).tasks)
        };
    } catch  {
        return structuredClone((0, $bf7fb22aa59e9c16$export$49d5fc8cba920a0));
    }
}
function $fe3908612a21a758$export$fb931cd598921492(state) {
    localStorage.setItem((0, $45af14c00f07ca1e$export$86880b4b2e1a2384), JSON.stringify(state));
}



function $61395636afd8b3a9$export$a1d87755f3c9500d() {
    return localStorage.getItem((0, $45af14c00f07ca1e$export$daa7e859aba5ce88)) || $61395636afd8b3a9$export$fe979c3403443f94();
}
function $61395636afd8b3a9$export$fe979c3403443f94() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function $61395636afd8b3a9$export$49e16ec648d05eb2(theme, themeToggle) {
    document.documentElement.dataset.theme = theme;
    themeToggle.checked = theme === "dark";
    localStorage.setItem((0, $45af14c00f07ca1e$export$daa7e859aba5ce88), theme);
    themeToggle.setAttribute("aria-label", `Activate ${theme === "dark" ? "light" : "dark"} mode`);
    themeToggle.parentElement.querySelector("span").textContent = theme === "dark" ? "Light Mode" : "Dark Mode";
}
function $61395636afd8b3a9$export$bb0fecbb07d25238() {
    return localStorage.getItem((0, $45af14c00f07ca1e$export$e3ade8805ed84548)) || "blue";
}
function $61395636afd8b3a9$export$e994949bcda46cdb(color, options) {
    document.documentElement.dataset.color = color;
    localStorage.setItem((0, $45af14c00f07ca1e$export$e3ade8805ed84548), color);
    options.forEach((btn)=>{
        btn.classList.toggle("active", btn.dataset.color === color);
    });
}



const $dfb109408c3536d4$export$8c2dcb2c27621b05 = [
    {
        "quote": "The only way to do great work is to love what you do.",
        "author": "Steve Jobs"
    },
    {
        "quote": "It does not matter how slowly you go as long as you do not stop.",
        "author": "Confucius"
    },
    {
        "quote": "Talk is cheap. Show me the code.",
        "author": "Linus Torvalds"
    },
    {
        "quote": "The future depends on what you do today.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "Programs must be written for people to read, and only incidentally for machines to execute.",
        "author": "Harold Abelson"
    },
    {
        "quote": "Your time is limited, don't waste it living someone else's life.",
        "author": "Steve Jobs"
    },
    {
        "quote": "First, solve the problem. Then, write the code.",
        "author": "John Johnson"
    },
    {
        "quote": "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
        "author": "Aristotle"
    },
    {
        "quote": "The most damaging phrase in the language is 'We've always done it this way.'",
        "author": "Grace Hopper"
    },
    {
        "quote": "Simplicity is the soul of efficiency.",
        "author": "Austin Freeman"
    },
    {
        "quote": "Learning never exhausts the mind.",
        "author": "Leonardo da Vinci"
    },
    {
        "quote": "Any fool can write code that a computer can understand. Good programmers write code that humans can understand.",
        "author": "Martin Fowler"
    },
    {
        "quote": "It\u2019s not that I\u2019m so smart, it\u2019s just that I stay with problems longer.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Make it work, make it right, make it fast.",
        "author": "Kent Beck"
    },
    {
        "quote": "The secret of getting ahead is getting started.",
        "author": "Mark Twain"
    },
    {
        "quote": "Engineering is the closest thing to magic that exists in the real world.",
        "author": "Elon Musk"
    },
    {
        "quote": "The only source of knowledge is experience.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Clean code always looks like it was written by someone who cares.",
        "author": "Robert C. Martin"
    },
    {
        "quote": "Whether you think you can or you think you can't, you're right.",
        "author": "Henry Ford"
    },
    {
        "quote": "Perfection is achieved not when there is nothing more to add, but when there is nothing left to take away.",
        "author": "Antoine de Saint-Exup\xe9ry"
    },
    {
        "quote": "The difference between a successful person and others is not a lack of strength, not a lack of knowledge, but rather a lack in will.",
        "author": "Vince Lombardi"
    },
    {
        "quote": "Optimism is an occupational hazard of programming: feedback is the treatment.",
        "author": "Kent Beck"
    },
    {
        "quote": "The best time to plant a tree was 20 years ago. The second best time is now.",
        "author": "Chinese Proverb"
    },
    {
        "quote": "In software, the most beautiful code, the most beautiful functions, and the most beautiful programs are sometimes not there.",
        "author": "Bjarne Stroustrup"
    },
    {
        "quote": "Success is not final, failure is not fatal: it is the courage to continue that counts.",
        "author": "Winston Churchill"
    },
    {
        "quote": "The function of good software is to make the complex appear to be simple.",
        "author": "Grady Booch"
    },
    {
        "quote": "Do the difficult things while they are easy and do the great things while they are small.",
        "author": "Lao Tzu"
    },
    {
        "quote": "Fix the cause, not the symptom.",
        "author": "Steve Maguire"
    },
    {
        "quote": "Happiness is when what you think, what you say, and what you do are in harmony.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "The expert in anything was once a beginner.",
        "author": "Helen Hayes"
    },
    {
        "quote": "Code is like humor. When you have to explain it, it\u2019s bad.",
        "author": "Cory House"
    },
    {
        "quote": "Believe you can and you're halfway there.",
        "author": "Theodore Roosevelt"
    },
    {
        "quote": "Debugging is twice as hard as writing the code in the first place. Therefore, if you write the code as cleverly as possible, you are, by definition, not smart enough to debug it.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "The only limit to our realization of tomorrow will be our doubts of today.",
        "author": "Franklin D. Roosevelt"
    },
    {
        "quote": "Theory is when you know everything but nothing works. Practice is when everything works but no one knows why. In our lab, theory and practice are combined: nothing works and no one knows why.",
        "author": "Anonymous"
    },
    {
        "quote": "Don't watch the clock; do what it does. Keep going.",
        "author": "Sam Levenson"
    },
    {
        "quote": "The most important property of a program is whether it accomplishes the intention of its user.",
        "author": "C.A.R. Hoare"
    },
    {
        "quote": "What you get by achieving your goals is not as important as what you become by achieving your goals.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "A goal without a plan is just a wish.",
        "author": "Antoine de Saint-Exup\xe9ry"
    },
    {
        "quote": "Programming isn't about what you know; it's about what you can figure out.",
        "author": "Chris Pine"
    },
    {
        "quote": "The only person you are destined to become is the person you decide to be.",
        "author": "Ralph Waldo Emerson"
    },
    {
        "quote": "Good design is as little design as possible.",
        "author": "Dieter Rams"
    },
    {
        "quote": "Don't be afraid to give up the good to go for the great.",
        "author": "John D. Rockefeller"
    },
    {
        "quote": "Software is a great combination between artistry and engineering.",
        "author": "Bill Gates"
    },
    {
        "quote": "You don't have to be great to start, but you have to start to be great.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "The best error message is the one that never shows up.",
        "author": "Thomas Fuchs"
    },
    {
        "quote": "Knowing is not enough; we must apply. Wishing is not enough; we must do.",
        "author": "Johann Wolfgang von Goethe"
    },
    {
        "quote": "The only way to learn a new programming language is by writing programs in it.",
        "author": "Dennis Ritchie"
    },
    {
        "quote": "If you can't explain it simply, you don't understand it well enough.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Success is the sum of small efforts, repeated day in and day out.",
        "author": "Robert Collier"
    },
    {
        "quote": "One of the best programming skills you can have is knowing when to walk away for a while.",
        "author": "Anonymous"
    },
    {
        "quote": "Fall seven times, stand up eight.",
        "author": "Japanese Proverb"
    },
    {
        "quote": "The most likely way for the world to be destroyed, most experts agree, is by accident. That's where we come in; we're computer professionals. We cause accidents.",
        "author": "Nathaniel Borenstein"
    },
    {
        "quote": "Success usually comes to those who are too busy to be looking for it.",
        "author": "Henry David Thoreau"
    },
    {
        "quote": "The best way to predict the future is to implement it.",
        "author": "David Heinemeier Hansson"
    },
    {
        "quote": "Quality is not an act, it is a habit.",
        "author": "Aristotle"
    },
    {
        "quote": "The most fundamental problem in software development is complexity.",
        "author": "David Parnas"
    },
    {
        "quote": "What we think, we become.",
        "author": "Buddha"
    },
    {
        "quote": "Engineering is the art of organizing and directing men and materials, and controlling the forces of nature for the benefit of the human race.",
        "author": "Henry G. Stott"
    },
    {
        "quote": "The secret of change is to focus all of your energy not on fighting the old, but on building the new.",
        "author": "Socrates"
    },
    {
        "quote": "Controlling complexity is the essence of computer programming.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "Do not wait to strike till the iron is hot; but make it hot by striking.",
        "author": "William Butler Yeats"
    },
    {
        "quote": "Programming today is a race between software engineers striving to build bigger and better idiot-proof programs, and the universe trying to produce bigger and better idiots. So far, the universe is winning.",
        "author": "Rick Cook"
    },
    {
        "quote": "Small minds discuss people. Average minds discuss events. Great minds discuss ideas.",
        "author": "Eleanor Roosevelt"
    },
    {
        "quote": "The hardest part of design... is keeping features out.",
        "author": "Donald Norman"
    },
    {
        "quote": "You cannot teach a man anything; you can only help him find it within himself.",
        "author": "Galileo Galilei"
    },
    {
        "quote": "A problem well stated is a problem half solved.",
        "author": "Charles Kettering"
    },
    {
        "quote": "Discipline is the bridge between goals and accomplishment.",
        "author": "Jim Rohn"
    },
    {
        "quote": "The sooner you start to code, the longer the code will take to finish.",
        "author": "Anonymous"
    },
    {
        "quote": "There are no shortcuts to any place worth going.",
        "author": "Beverly Sills"
    },
    {
        "quote": "The computer was born to solve problems that did not exist before.",
        "author": "Bill Gates"
    },
    {
        "quote": "Start where you are. Use what you have. Do what you can.",
        "author": "Arthur Ashe"
    },
    {
        "quote": "The function of a good system is to make complex things look simple.",
        "author": "Grady Booch"
    },
    {
        "quote": "Successful people are not gifted; they just work hard, then succeed on purpose.",
        "author": "G.K. Nielson"
    },
    {
        "quote": "The best way to prepare for the future is to invent it.",
        "author": "Alan Kay"
    },
    {
        "quote": "It always seems impossible until it's done.",
        "author": "Nelson Mandela"
    },
    {
        "quote": "Measuring programming progress by lines of code is like measuring aircraft building progress by weight.",
        "author": "Bill Gates"
    },
    {
        "quote": "The greatest glory in living lies not in never falling, but in rising every time we fall.",
        "author": "Nelson Mandela"
    },
    {
        "quote": "If debugging is the process of removing bugs, then programming must be the process of putting them in.",
        "author": "Edsger Dijkstra"
    },
    {
        "quote": "You miss 100% of the shots you don't take.",
        "author": "Wayne Gretzky"
    },
    {
        "quote": "Engineering is not only about building things, it's about building things right.",
        "author": "Anonymous"
    },
    {
        "quote": "The only true wisdom is in knowing you know nothing.",
        "author": "Socrates"
    },
    {
        "quote": "Code never lies, comments sometimes do.",
        "author": "Ron Jeffries"
    },
    {
        "quote": "Act as if what you do makes a difference. It does.",
        "author": "William James"
    },
    {
        "quote": "It's not a bug; it's an undocumented feature.",
        "author": "Anonymous"
    },
    {
        "quote": "You can have data without information, but you cannot have information without data.",
        "author": "Daniel Keys Moran"
    },
    {
        "quote": "Dream big and dare to fail.",
        "author": "Norman Vaughan"
    },
    {
        "quote": "A computer lets you make more mistakes faster than any other invention in human history, with the possible exceptions of handguns and tequila.",
        "author": "Mitch Ratcliffe"
    },
    {
        "quote": "The price of success is hard work, dedication to the job at hand, and the determination that whether we win or lose, we have applied the best of ourselves to the task at hand.",
        "author": "Vince Lombardi"
    },
    {
        "quote": "First, do no harm.",
        "author": "Hippocrates (applies to engineering ethics)"
    },
    {
        "quote": "Don't comment bad code\u2014rewrite it.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "Challenges are what make life interesting. Overcoming them is what makes life meaningful.",
        "author": "Joshua J. Marine"
    },
    {
        "quote": "The electric light did not come from the continuous improvement of candles.",
        "author": "Oren Harari"
    },
    {
        "quote": "Keep it simple, stupid (KISS).",
        "author": "Kelly Johnson"
    },
    {
        "quote": "You are never too old to set another goal or to dream a new dream.",
        "author": "C.S. Lewis"
    },
    {
        "quote": "Machines take me by surprise with great frequency.",
        "author": "Alan Turing"
    },
    {
        "quote": "The secret of success is to do the common things uncommonly well.",
        "author": "John D. Rockefeller Jr."
    },
    {
        "quote": "Before software can be reusable, it first has to be usable.",
        "author": "Ralph Johnson"
    },
    {
        "quote": "Everything you\u2019ve ever wanted is on the other side of fear.",
        "author": "George Addair"
    },
    {
        "quote": "Think twice, code once.",
        "author": "Anonymous"
    },
    {
        "quote": "Innovation distinguishes between a leader and a follower.",
        "author": "Steve Jobs"
    },
    {
        "quote": "If at first you don't succeed, call it version 1.0.",
        "author": "Anonymous"
    },
    {
        "quote": "It's not about ideas. It's about making ideas happen.",
        "author": "Scott Belsky"
    },
    {
        "quote": "The most important single aspect of software development is to be clear about what you are trying to build.",
        "author": "Bjarne Stroustrup"
    },
    {
        "quote": "Your most unhappy customers are your greatest source of learning.",
        "author": "Bill Gates"
    },
    {
        "quote": "Courage is grace under pressure.",
        "author": "Ernest Hemingway"
    },
    {
        "quote": "When debugging, novices insert corrective code; experts remove defective code.",
        "author": "Richard Pattis"
    },
    {
        "quote": "The way to get started is to quit talking and begin doing.",
        "author": "Walt Disney"
    },
    {
        "quote": "Testing leads to failure, and failure leads to understanding.",
        "author": "Burt Rutan"
    },
    {
        "quote": "It\u2019s not the will to win that matters\u2014everyone has that. It\u2019s the will to prepare to win that matters.",
        "author": "Paul ",
        "author": "Bear Bryant"
    },
    {
        "quote": "Make everything as simple as possible, but not simpler.",
        "author": "Albert Einstein"
    },
    {
        "quote": "The only difference between a bug and a feature is how you document it.",
        "author": "Anonymous"
    },
    {
        "quote": "Do not be embarrassed by your failures, learn from them and start again.",
        "author": "Richard Branson"
    },
    {
        "quote": "One accurate measurement is worth a thousand expert opinions.",
        "author": "Grace Hopper"
    },
    {
        "quote": "Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful.",
        "author": "Albert Schweitzer"
    },
    {
        "quote": "Deleted code is debugged code.",
        "author": "Jeff Sickel"
    },
    {
        "quote": "The best way to predict your future is to create it.",
        "author": "Peter Drucker"
    },
    {
        "quote": "Simplicity is the ultimate sophistication.",
        "author": "Leonardo da Vinci"
    },
    {
        "quote": "The most effective debugging tool is still careful thought, coupled with judiciously placed print statements.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "Every problem is a gift\u2014without problems we would not grow.",
        "author": "Anthony Robbins"
    },
    {
        "quote": "Good programmers know what to write. Great ones know what to rewrite (and reuse).",
        "author": "Eric S. Raymond"
    },
    {
        "quote": "Form follows function.",
        "author": "Louis Sullivan"
    },
    {
        "quote": "The pain you feel today will be the strength you feel tomorrow.",
        "author": "Anonymous"
    },
    {
        "quote": "Beware of bugs in the above code; I have only proved it correct, not tried it.",
        "author": "Donald Knuth"
    },
    {
        "quote": "Be a student as long as you still have something to learn, and this will mean all your life.",
        "author": "Henry L. Doherty"
    },
    {
        "quote": "Engineering is the art of directing the great sources of power in nature for the use and convenience of man.",
        "author": "Thomas Tredgold"
    },
    {
        "quote": "Great things are not done by impulse, but by a series of small things brought together.",
        "author": "Vincent van Gogh"
    },
    {
        "quote": "Treat your users as you would want to be treated.",
        "author": "Anonymous (UX principle)"
    },
    {
        "quote": "The secret of productivity is not doing more, but doing what matters.",
        "author": "Anonymous"
    },
    {
        "quote": "Progress is impossible without change, and those who cannot change their minds cannot change anything.",
        "author": "George Bernard Shaw"
    },
    {
        "quote": "Hardware: the parts of a computer that you can kick. Software: the parts you can only curse at.",
        "author": "Anonymous"
    },
    {
        "quote": "Learn the rules like a pro, so you can break them like an artist.",
        "author": "Pablo Picasso"
    },
    {
        "quote": "The goal of engineering is to eliminate the need for engineering.",
        "author": "Anonymous"
    },
    {
        "quote": "Ambition is the path to success. Persistence is the vehicle you arrive in.",
        "author": "Bill Bradley"
    },
    {
        "quote": "The only reason to write code is to solve someone's problem.",
        "author": "Anonymous"
    },
    {
        "quote": "The great aim of education is not knowledge but action.",
        "author": "Herbert Spencer"
    },
    {
        "quote": "If you want to build a ship, don't drum up people to collect wood and don't assign them tasks and work, but rather teach them to long for the endless immensity of the sea.",
        "author": "Antoine de Saint-Exup\xe9ry"
    },
    {
        "quote": "There is no such thing as a perfect program. But we can strive for excellence.",
        "author": "Anonymous"
    },
    {
        "quote": "Productivity is being able to do things that you were never able to do before.",
        "author": "Franz Kafka"
    },
    {
        "quote": "The engineer's first problem in any design is to figure out what the problem really is.",
        "author": "Anonymous"
    },
    {
        "quote": "You don't need to see the whole staircase, just take the first step.",
        "author": "Martin Luther King Jr."
    },
    {
        "quote": "The fastest algorithm can be slowed down by a slow programmer.",
        "author": "Anonymous"
    },
    {
        "quote": "The ability to simplify means to eliminate the unnecessary so that the necessary may speak.",
        "author": "Hans Hofmann"
    },
    {
        "quote": "Success is walking from failure to failure with no loss of enthusiasm.",
        "author": "Winston Churchill"
    },
    {
        "quote": "In theory, theory and practice are the same. In practice, they are not.",
        "author": "Yogi Berra"
    },
    {
        "quote": "An investment in knowledge pays the best interest.",
        "author": "Benjamin Franklin"
    },
    {
        "quote": "The more you know, the more you realize you don't know.",
        "author": "Aristotle"
    },
    {
        "quote": "Relying on users to find bugs is like relying on a dog to find truffles\u2014possible but unreliable.",
        "author": "Anonymous"
    },
    {
        "quote": "Strive not to be a success, but rather to be of value.",
        "author": "Albert Einstein"
    },
    {
        "quote": "The best design is the simplest one that works.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Every great developer you know got there by solving problems they were unqualified to solve until they actually did.",
        "author": "Patrick McKenzie"
    },
    {
        "quote": "The secret of change is to focus all of your energy not on fighting the old, but on building the new.",
        "author": "Dan Millman"
    },
    {
        "quote": "A good API is not just easy to use but also hard to misuse.",
        "author": "Anonymous"
    },
    {
        "quote": "The only thing standing between you and your goal is the story you keep telling yourself.",
        "author": "Tony Robbins"
    },
    {
        "quote": "Documentation is a love letter that you write to your future self.",
        "author": "Damian Conway"
    },
    {
        "quote": "Knowledge is power, but enthusiasm pulls the switch.",
        "author": "Ivern Ball"
    },
    {
        "quote": "The most important property of a program is that it should be correct.",
        "author": "C.A.R. Hoare"
    },
    {
        "quote": "Success is not how high you have climbed, but how you make a positive difference to the world.",
        "author": "Roy T. Bennett"
    },
    {
        "quote": "The art of debugging is figuring out what you really told your program to do rather than what you thought you told it to do.",
        "author": "Andrew Singer"
    },
    {
        "quote": "The future belongs to those who learn more skills and combine them in creative ways.",
        "author": "Robert Greene"
    },
    {
        "quote": "If you want to go fast, go alone. If you want to go far, go together.",
        "author": "African Proverb"
    },
    {
        "quote": "A user interface is like a joke. If you have to explain it, it's not that good.",
        "author": "Anonymous"
    },
    {
        "quote": "Courage is being scared to death but saddling up anyway.",
        "author": "John Wayne"
    },
    {
        "quote": "The best code is no code at all.",
        "author": "Jeff Atwood"
    },
    {
        "quote": "You can't have a million-dollar dream with a minimum-wage work ethic.",
        "author": "Stephen C. Hogan"
    },
    {
        "quote": "Make it correct, make it clear, make it concise, make it fast. In that order.",
        "author": "Wes Dyer"
    },
    {
        "quote": "The expert at anything was once a beginner.",
        "author": "Anonymous"
    },
    {
        "quote": "Weeks of coding can save you hours of planning.",
        "author": "Anonymous"
    },
    {
        "quote": "If you think you are too small to make a difference, try sleeping with a mosquito.",
        "author": "Dalai Lama"
    },
    {
        "quote": "Software is like entropy: It is difficult to grasp, weighs nothing, and obeys the Second Law of Thermodynamics; i.e., it always increases.",
        "author": "Norman Augustine"
    },
    {
        "quote": "The man who moves a mountain begins by carrying away small stones.",
        "author": "Confucius"
    },
    {
        "quote": "A shared codebase is like a shared bathroom. Clean up after yourself.",
        "author": "Anonymous"
    },
    {
        "quote": "Do what you can, with what you have, where you are.",
        "author": "Theodore Roosevelt"
    },
    {
        "quote": "The most fundamental problem in programming is the management of complexity.",
        "author": "David Parnas"
    },
    {
        "quote": "Perseverance is not a long race; it is many short races one after the other.",
        "author": "Walter Elliot"
    },
    {
        "quote": "Your job is not to write code; your job is to solve problems. Code is just the language you use.",
        "author": "Anonymous"
    },
    {
        "quote": "The only limit to our realization of tomorrow is our doubts of today.",
        "author": "Franklin D. Roosevelt"
    },
    {
        "quote": "Functionality sells, but elegance keeps.",
        "author": "Anonymous"
    },
    {
        "quote": "The dictionary is the only place where success comes before work.",
        "author": "Vince Lombardi"
    },
    {
        "quote": "The best way to have a good idea is to have a lot of ideas.",
        "author": "Linus Pauling"
    },
    {
        "quote": "Code is read more often than it is written.",
        "author": "Guido van Rossum"
    },
    {
        "quote": "Success is not the absence of failure; it's the persistence through failure.",
        "author": "Aisha Tyler"
    },
    {
        "quote": "Engineers like to solve problems. If there are no problems handily available, they will create their own problems.",
        "author": "Scott Adams"
    },
    {
        "quote": "Don't be pushed around by the fears in your mind. Be led by the dreams in your heart.",
        "author": "Roy T. Bennett"
    },
    {
        "quote": "The best performance improvement is the transition from the nonworking state to the working state.",
        "author": "J. Osterhout"
    },
    {
        "quote": "Small daily improvements over time lead to stunning results.",
        "author": "Robin Sharma"
    },
    {
        "quote": "Any sufficiently advanced technology is indistinguishable from magic.",
        "author": "Arthur C. Clarke"
    },
    {
        "quote": "The most important thing in programming is the ability to learn, not the knowledge you currently have.",
        "author": "Anonymous"
    },
    {
        "quote": "The secret of getting things done is to act on your priorities, not just your urgencies.",
        "author": "Stephen Covey"
    },
    {
        "quote": "Everything should be built top-down, except the first time.",
        "author": "Donald Knuth"
    },
    {
        "quote": "Don't let yesterday take up too much of today.",
        "author": "Will Rogers"
    },
    {
        "quote": "Plan to throw one away; you will, anyhow.",
        "author": "Fred Brooks"
    },
    {
        "quote": "The greatest enemy of knowledge is not ignorance, it is the illusion of knowledge.",
        "author": "Stephen Hawking"
    },
    {
        "quote": "The goal of a software engineer is to write code that is simple, readable, and maintainable.",
        "author": "Anonymous"
    },
    {
        "quote": "It does not do to dwell on dreams and forget to live.",
        "author": "J.K. Rowling"
    },
    {
        "quote": "Premature optimization is the root of all evil.",
        "author": "Donald Knuth"
    },
    {
        "quote": "Live as if you were to die tomorrow. Learn as if you were to live forever.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "You can't build a great building on a weak foundation. The same goes for code.",
        "author": "Anonymous"
    },
    {
        "quote": "If you want to live a happy life, tie it to a goal, not to people or things.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Code is like poetry; it should be elegant, concise, and meaningful.",
        "author": "Anonymous"
    },
    {
        "quote": "The only real mistake is the one from which we learn nothing.",
        "author": "Henry Ford"
    },
    {
        "quote": "The difference between theory and practice is smaller in theory than in practice.",
        "author": "Anonymous"
    },
    {
        "quote": "Success is how high you bounce when you hit bottom.",
        "author": "George S. Patton"
    },
    {
        "quote": "Tools don't solve problems; people do.",
        "author": "Anonymous"
    },
    {
        "quote": "The secret of success is to start before you are ready.",
        "author": "Marie Forleo"
    },
    {
        "quote": "If you can't measure it, you can't improve it.",
        "author": "Peter Drucker"
    },
    {
        "quote": "The hardest part of programming is naming things and cache invalidation.",
        "author": "Phil Karlton"
    },
    {
        "quote": "Focus on being productive instead of busy.",
        "author": "Tim Ferriss"
    },
    {
        "quote": "It\u2019s not what you look at that matters, it\u2019s what you see.",
        "author": "Henry David Thoreau"
    },
    {
        "quote": "Beware of false knowledge; it is more dangerous than ignorance.",
        "author": "George Bernard Shaw"
    },
    {
        "quote": "The only way to do great work is to first do work.",
        "author": "Anonymous"
    },
    {
        "quote": "Programming is the art of telling another human what one wants the computer to do.",
        "author": "Donald Knuth"
    },
    {
        "quote": "You don't have to see the whole path, just take the next step.",
        "author": "Martin Luther King Jr."
    },
    {
        "quote": "Complexity is your enemy. Any fool can make something complicated. It is hard to make something simple.",
        "author": "Richard Branson"
    },
    {
        "quote": "If it hurts, do it more often.",
        "author": "Martin Fowler (on continuous integration)"
    },
    {
        "quote": "Your work is to discover your work and then with all your heart to give yourself to it.",
        "author": "Buddha"
    },
    {
        "quote": "The most dangerous thought you can have as a creative person is to think you already know what you're doing.",
        "author": "Anonymous"
    },
    {
        "quote": "Testing without understanding is just guessing.",
        "author": "Anonymous"
    },
    {
        "quote": "The secret of happiness is freedom, and the secret of freedom is courage.",
        "author": "Thucydides"
    },
    {
        "quote": "The first 90% of the code accounts for the first 90% of the development time. The remaining 10% of the code accounts for the other 90% of the development time.",
        "author": "Tom Cargill"
    },
    {
        "quote": "What you do today can improve all your tomorrows.",
        "author": "Ralph Marston"
    },
    {
        "quote": "Make it work, then make it beautiful, then if you really, really have to, make it fast.",
        "author": "Joe Armstrong"
    },
    {
        "quote": "The only way to achieve the impossible is to believe it is possible.",
        "author": "Charles Kingsleigh"
    },
    {
        "quote": "The best code is the code that never has to be written.",
        "author": "Anonymous"
    },
    {
        "quote": "Life is 10% what happens to us and 90% how we react to it.",
        "author": "Charles R. Swindoll"
    },
    {
        "quote": "Simplicity is the key to brilliance.",
        "author": "Bruce Lee"
    },
    {
        "quote": "The most important thing about a program is its maintainability.",
        "author": "Anonymous"
    },
    {
        "quote": "Never let the fear of striking out keep you from playing the game.",
        "author": "Babe Ruth"
    },
    {
        "quote": "First make it work, then make it right, and, yes, then make it fast.",
        "author": "Kent Beck"
    },
    {
        "quote": "It is not the mountain we conquer, but ourselves.",
        "author": "Edmund Hillary"
    },
    {
        "quote": "The best way to get a project done faster is to start sooner.",
        "author": "Jim Highsmith"
    },
    {
        "quote": "Success is not in what you have, but who you are.",
        "author": "Bo Bennett"
    },
    {
        "quote": "You can't improve what you don't measure.",
        "author": "Anonymous"
    },
    {
        "quote": "The best revenge is massive success.",
        "author": "Frank Sinatra"
    },
    {
        "quote": "The quality of your questions determines the quality of your life.",
        "author": "Tony Robbins"
    },
    {
        "quote": "Engineering is about making things. Making things work. Making things work better.",
        "author": "Anonymous"
    },
    {
        "quote": "Limitations live only in our minds. But if we use our imaginations, our possibilities become limitless.",
        "author": "Jamie Paolinetti"
    },
    {
        "quote": "The hardest bugs are those where the code is doing exactly what you told it to do, not what you wanted it to do.",
        "author": "Anonymous"
    },
    {
        "quote": "The more you learn, the more you earn.",
        "author": "Frank Clark"
    },
    {
        "quote": "Great software is built by great teams, not by great individuals.",
        "author": "Anonymous"
    },
    {
        "quote": "The future is already here \u2013 it's just not evenly distributed.",
        "author": "William Gibson"
    },
    {
        "quote": "The only thing worse than training your employees and losing them is not training them and keeping them.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "A good programmer is someone who always looks both ways before crossing a one-way street.",
        "author": "Doug Linder"
    },
    {
        "quote": "Your attitude, not your aptitude, will determine your altitude.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "Design is not just what it looks like and feels like. Design is how it works.",
        "author": "Steve Jobs"
    },
    {
        "quote": "One man's constant is another man's variable.",
        "author": "Alan Perlis"
    },
    {
        "quote": "The only person you should try to be better than is the person you were yesterday.",
        "author": "Anonymous"
    },
    {
        "quote": "The most important tool in programming is your brain.",
        "author": "Anonymous"
    },
    {
        "quote": "Either you run the day or the day runs you.",
        "author": "Jim Rohn"
    },
    {
        "quote": "Make it easy for the right thing to be the default thing.",
        "author": "Anonymous (UX)"
    },
    {
        "quote": "The best way to appreciate your job is to imagine yourself without one.",
        "author": "Oscar Wilde"
    },
    {
        "quote": "Don't be afraid to ask stupid questions; they are easier to handle than stupid mistakes.",
        "author": "Anonymous"
    },
    {
        "quote": "The strength of the team is each individual member. The strength of each member is the team.",
        "author": "Phil Jackson"
    },
    {
        "quote": "Code that works is a good start. Code that works and is maintainable is the goal.",
        "author": "Anonymous"
    },
    {
        "quote": "Success is the child of audacity.",
        "author": "Benjamin Disraeli"
    },
    {
        "quote": "The secret of change is to focus all of your energy not on fighting the old, but on building the new.",
        "author": "Socrates"
    },
    {
        "quote": "Coding is not just about solving problems, it's about preventing them.",
        "author": "Anonymous"
    },
    {
        "quote": "The successful warrior is the average man, with laser-like focus.",
        "author": "Bruce Lee"
    },
    {
        "quote": "The only way to have a good idea is to have many ideas, then throw away the bad ones.",
        "author": "Linus Pauling"
    },
    {
        "quote": "The first step in solving a problem is admitting you have one.",
        "author": "Anonymous"
    },
    {
        "quote": "The key to productivity is not doing more things, but doing the right things.",
        "author": "Anonymous"
    },
    {
        "quote": "Testing is the process of comparing the invisible to the ambiguous, so as to avoid the unthinkable happening to the anonymous.",
        "author": "James Bach"
    },
    {
        "quote": "Genius is one percent inspiration and ninety-nine percent perspiration.",
        "author": "Thomas Edison"
    },
    {
        "quote": "The purpose of abstraction is not to be vague, but to create a new semantic level in which one can be absolutely precise.",
        "author": "Edsger Dijkstra"
    },
    {
        "quote": "Success is not in never falling, but in rising every time we fall.",
        "author": "Confucius"
    },
    {
        "quote": "If you are not embarrassed by the first version of your product, you've launched too late.",
        "author": "Reid Hoffman"
    },
    {
        "quote": "The most important property of a program is whether it is correct.",
        "author": "C.A.R. Hoare"
    },
    {
        "quote": "Hardships often prepare ordinary people for an extraordinary destiny.",
        "author": "C.S. Lewis"
    },
    {
        "quote": "The only way to finish is to start.",
        "author": "Anonymous"
    },
    {
        "quote": "Great minds discuss ideas; average minds discuss events; small minds discuss people.",
        "author": "Eleanor Roosevelt"
    },
    {
        "quote": "Engineering is the art of modelling materials we do not wholly understand, into shapes we cannot precisely analyze so as to withstand forces we cannot properly assess, in such a way that the public has no reason to suspect the extent of our ignorance.",
        "author": "Dr. A. R. Dykes"
    },
    {
        "quote": "Do not wait for the perfect moment. Take the moment and make it perfect.",
        "author": "Anonymous"
    },
    {
        "quote": "Your best teacher is your last mistake.",
        "author": "Anonymous"
    },
    {
        "quote": "The key to successful leadership is influence, not authority.",
        "author": "Kenneth H. Blanchard"
    },
    {
        "quote": "The only limit is your imagination.",
        "author": "Anonymous"
    },
    {
        "quote": "Perfection is not attainable, but if we chase perfection we can catch excellence.",
        "author": "Vince Lombardi"
    },
    {
        "quote": "The best code is the code that never has to be maintained because it is self-documenting.",
        "author": "Anonymous"
    },
    {
        "quote": "It always seems impossible until it's done.",
        "author": "Nelson Mandela"
    },
    {
        "quote": "If you want to double your success rate, double your failure rate.",
        "author": "Thomas J. Watson"
    },
    {
        "quote": "The most powerful tool in software development is the ability to change your mind.",
        "author": "Anonymous"
    },
    {
        "quote": "Action is the foundational key to all success.",
        "author": "Pablo Picasso"
    },
    {
        "quote": "The best way to predict the future is to invent it.",
        "author": "Alan Kay"
    },
    {
        "quote": "Don't count the days; make the days count.",
        "author": "Muhammad Ali"
    },
    {
        "quote": "The only true test of code is running it.",
        "author": "Anonymous"
    },
    {
        "quote": "Wisdom is not a product of schooling but of the lifelong attempt to acquire it.",
        "author": "Albert Einstein"
    },
    {
        "quote": "The best error message is the one that never appears.",
        "author": "Anonymous"
    },
    {
        "quote": "The secret of success is to know something nobody else knows.",
        "author": "Aristotle Onassis"
    },
    {
        "quote": "A design is finished not when there is nothing left to add, but when there is nothing left to take away.",
        "author": "Antoine de Saint-Exup\xe9ry"
    },
    {
        "quote": "The difference between a successful person and others is not a lack of strength, not a lack of knowledge, but rather a lack of will.",
        "author": "Vince Lombardi"
    },
    {
        "quote": "It's not about the hours you put in, but what you put in the hours.",
        "author": "Anonymous"
    },
    {
        "quote": "The most important thing in communication is hearing what isn't said.",
        "author": "Peter Drucker"
    },
    {
        "quote": "Code reuse is the Holy Grail of software engineering.",
        "author": "Anonymous"
    },
    {
        "quote": "Don't limit your challenges. Challenge your limits.",
        "author": "Anonymous"
    },
    {
        "quote": "The most dangerous risk of all is the risk of spending your life not doing what you want, on the bet you can buy yourself the freedom to do it later.",
        "author": "Anonymous"
    },
    {
        "quote": "If you can't explain it simply, you don't understand it well enough.",
        "author": "Albert Einstein"
    },
    {
        "quote": "The only way to do great work is to first love what you do.",
        "author": "Steve Jobs"
    },
    {
        "quote": "The greatest weapon against stress is our ability to choose one thought over another.",
        "author": "William James"
    },
    {
        "quote": "The most important skill for a programmer is the ability to learn.",
        "author": "Anonymous"
    },
    {
        "quote": "A person who never made a mistake never tried anything new.",
        "author": "Albert Einstein"
    },
    {
        "quote": "The best part of being an engineer is that you get to build things that matter.",
        "author": "Anonymous"
    },
    {
        "quote": "Do not go where the path may lead, go instead where there is no path and leave a trail.",
        "author": "Ralph Waldo Emerson"
    },
    {
        "quote": "The hardest part of software development is not the code, it's the people.",
        "author": "Anonymous"
    },
    {
        "quote": "Education is the most powerful weapon which you can use to change the world.",
        "author": "Nelson Mandela"
    },
    {
        "quote": "Simplicity is the ultimate form of sophistication.",
        "author": "Leonardo da Vinci"
    },
    {
        "quote": "The only thing standing between you and your goal is the story you keep telling yourself as to why you can't achieve it.",
        "author": "Jordan Belfort"
    },
    {
        "quote": "The most effective debugging tool is still careful thought, coupled with judiciously placed print statements.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "Your most unhappy customers are your greatest source of learning.",
        "author": "Bill Gates"
    },
    {
        "quote": "It's not the load that breaks you down, it's the way you carry it.",
        "author": "Lou Holtz"
    },
    {
        "quote": "The function of good software is to make the complex appear to be simple.",
        "author": "Grady Booch"
    },
    {
        "quote": "Good enough is the enemy of greatness.",
        "author": "Anonymous"
    },
    {
        "quote": "The difference between theory and practice is smaller in theory than in practice.",
        "author": "Anonymous"
    },
    {
        "quote": "What you get by achieving your goals is not as important as what you become by achieving your goals.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "The only source of knowledge is experience.",
        "author": "Albert Einstein"
    },
    {
        "quote": "You can have data without information, but you cannot have information without data.",
        "author": "Daniel Keys Moran"
    },
    {
        "quote": "The best way to get started is to quit talking and begin doing.",
        "author": "Walt Disney"
    },
    {
        "quote": "Happiness is when what you think, what you say, and what you do are in harmony.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "Learning never exhausts the mind.",
        "author": "Leonardo da Vinci"
    },
    {
        "quote": "The most important thing in programming is the ability to think.",
        "author": "Anonymous"
    },
    {
        "quote": "Success is not final, failure is not fatal: it is the courage to continue that counts.",
        "author": "Winston Churchill"
    },
    {
        "quote": "The best code is the code that you didn't have to write.",
        "author": "Anonymous"
    },
    {
        "quote": "The secret of getting ahead is getting started.",
        "author": "Mark Twain"
    },
    {
        "quote": "If you can dream it, you can do it.",
        "author": "Walt Disney"
    },
    {
        "quote": "The most important thing about a program is that it should be correct.",
        "author": "C.A.R. Hoare"
    },
    {
        "quote": "The future depends on what you do today.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "The only person you are destined to become is the person you decide to be.",
        "author": "Ralph Waldo Emerson"
    },
    {
        "quote": "The best way to predict the future is to implement it.",
        "author": "David Heinemeier Hansson"
    },
    {
        "quote": "Quality is not an act, it is a habit.",
        "author": "Aristotle"
    },
    {
        "quote": "The difference between a successful person and others is not a lack of strength, not a lack of knowledge, but rather a lack in will.",
        "author": "Vince Lombardi"
    },
    {
        "quote": "The best time to plant a tree was 20 years ago. The second best time is now.",
        "author": "Chinese Proverb"
    },
    {
        "quote": "Your time is limited, don't waste it living someone else's life.",
        "author": "Steve Jobs"
    },
    {
        "quote": "The only way to do great work is to love what you do.",
        "author": "Steve Jobs"
    },
    {
        "quote": "It does not matter how slowly you go as long as you do not stop.",
        "author": "Confucius"
    },
    {
        "quote": "Talk is cheap. Show me the code.",
        "author": "Linus Torvalds"
    },
    {
        "quote": "First, solve the problem. Then, write the code.",
        "author": "John Johnson"
    },
    {
        "quote": "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
        "author": "Aristotle"
    },
    {
        "quote": "The most damaging phrase in the language is 'We've always done it this way.'",
        "author": "Grace Hopper"
    },
    {
        "quote": "Simplicity is the soul of efficiency.",
        "author": "Austin Freeman"
    },
    {
        "quote": "Any fool can write code that a computer can understand. Good programmers write code that humans can understand.",
        "author": "Martin Fowler"
    },
    {
        "quote": "It\u2019s not that I\u2019m so smart, it\u2019s just that I stay with problems longer.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Make it work, make it right, make it fast.",
        "author": "Kent Beck"
    },
    {
        "quote": "The secret of getting ahead is getting started.",
        "author": "Mark Twain"
    },
    {
        "quote": "Engineering is the closest thing to magic that exists in the real world.",
        "author": "Elon Musk"
    },
    {
        "quote": "The only source of knowledge is experience.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Clean code always looks like it was written by someone who cares.",
        "author": "Robert C. Martin"
    },
    {
        "quote": "Whether you think you can or you think you can't, you're right.",
        "author": "Henry Ford"
    },
    {
        "quote": "Perfection is achieved not when there is nothing more to add, but when there is nothing left to take away.",
        "author": "Antoine de Saint-Exup\xe9ry"
    },
    {
        "quote": "Optimism is an occupational hazard of programming: feedback is the treatment.",
        "author": "Kent Beck"
    },
    {
        "quote": "In software, the most beautiful code, the most beautiful functions, and the most beautiful programs are sometimes not there.",
        "author": "Bjarne Stroustrup"
    },
    {
        "quote": "Success is not final, failure is not fatal: it is the courage to continue that counts.",
        "author": "Winston Churchill"
    },
    {
        "quote": "The function of good software is to make the complex appear to be simple.",
        "author": "Grady Booch"
    },
    {
        "quote": "Do the difficult things while they are easy and do the great things while they are small.",
        "author": "Lao Tzu"
    },
    {
        "quote": "Fix the cause, not the symptom.",
        "author": "Steve Maguire"
    },
    {
        "quote": "Happiness is when what you think, what you say, and what you do are in harmony.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "The expert in anything was once a beginner.",
        "author": "Helen Hayes"
    },
    {
        "quote": "Code is like humor. When you have to explain it, it\u2019s bad.",
        "author": "Cory House"
    },
    {
        "quote": "Believe you can and you're halfway there.",
        "author": "Theodore Roosevelt"
    },
    {
        "quote": "Debugging is twice as hard as writing the code in the first place. Therefore, if you write the code as cleverly as possible, you are, by definition, not smart enough to debug it.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "The only limit to our realization of tomorrow will be our doubts of today.",
        "author": "Franklin D. Roosevelt"
    },
    {
        "quote": "Don't watch the clock; do what it does. Keep going.",
        "author": "Sam Levenson"
    },
    {
        "quote": "The most important property of a program is whether it accomplishes the intention of its user.",
        "author": "C.A.R. Hoare"
    },
    {
        "quote": "What you get by achieving your goals is not as important as what you become by achieving your goals.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "A goal without a plan is just a wish.",
        "author": "Antoine de Saint-Exup\xe9ry"
    },
    {
        "quote": "Programming isn't about what you know; it's about what you can figure out.",
        "author": "Chris Pine"
    },
    {
        "quote": "The only person you are destined to become is the person you decide to be.",
        "author": "Ralph Waldo Emerson"
    },
    {
        "quote": "Good design is as little design as possible.",
        "author": "Dieter Rams"
    },
    {
        "quote": "Don't be afraid to give up the good to go for the great.",
        "author": "John D. Rockefeller"
    },
    {
        "quote": "Software is a great combination between artistry and engineering.",
        "author": "Bill Gates"
    },
    {
        "quote": "You don't have to be great to start, but you have to start to be great.",
        "author": "Zig Ziglar"
    },
    {
        "quote": "The best error message is the one that never shows up.",
        "author": "Thomas Fuchs"
    },
    {
        "quote": "Knowing is not enough; we must apply. Wishing is not enough; we must do.",
        "author": "Johann Wolfgang von Goethe"
    },
    {
        "quote": "The only way to learn a new programming language is by writing programs in it.",
        "author": "Dennis Ritchie"
    },
    {
        "quote": "If you can't explain it simply, you don't understand it well enough.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Success is the sum of small efforts, repeated day in and day out.",
        "author": "Robert Collier"
    },
    {
        "quote": "One of the best programming skills you can have is knowing when to walk away for a while.",
        "author": "Anonymous"
    },
    {
        "quote": "Fall seven times, stand up eight.",
        "author": "Japanese Proverb"
    },
    {
        "quote": "Success usually comes to those who are too busy to be looking for it.",
        "author": "Henry David Thoreau"
    },
    {
        "quote": "The best way to predict the future is to implement it.",
        "author": "David Heinemeier Hansson"
    },
    {
        "quote": "Quality is not an act, it is a habit.",
        "author": "Aristotle"
    },
    {
        "quote": "The most fundamental problem in software development is complexity.",
        "author": "David Parnas"
    },
    {
        "quote": "What we think, we become.",
        "author": "Buddha"
    },
    {
        "quote": "Engineering is the art of organizing and directing men and materials, and controlling the forces of nature for the benefit of the human race.",
        "author": "Henry G. Stott"
    },
    {
        "quote": "The secret of change is to focus all of your energy not on fighting the old, but on building the new.",
        "author": "Socrates"
    },
    {
        "quote": "Controlling complexity is the essence of computer programming.",
        "author": "Brian Kernighan"
    },
    {
        "quote": "Do not wait to strike till the iron is hot; but make it hot by striking.",
        "author": "William Butler Yeats"
    }
];


function $0e02ef8675b4c97a$export$24aeb49d8df64e00() {
    const raw = localStorage.getItem((0, $45af14c00f07ca1e$export$aeee6467aa99f8c2));
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch  {
        return null;
    }
}
function $0e02ef8675b4c97a$export$144a039f695a9941(quote) {
    const data = {
        date: new Date().toDateString(),
        quote: quote
    };
    localStorage.setItem((0, $45af14c00f07ca1e$export$aeee6467aa99f8c2), JSON.stringify(data));
}
async function $0e02ef8675b4c97a$export$c5346dc8f6de2ad9(displayQuoteFn) {
    try {
        const response = await fetch((0, $45af14c00f07ca1e$export$689f758a17cbcc4b));
        if (!response.ok) throw new Error("Failed to fetch quote");
        const quote = await response.json();
        $0e02ef8675b4c97a$export$144a039f695a9941(quote);
        displayQuoteFn(quote);
    } catch (error) {
        console.error("Error fetching quote:", error);
        const fallbackQuote = $0e02ef8675b4c97a$var$getRandomFallbackQuote((0, $dfb109408c3536d4$export$8c2dcb2c27621b05));
        $0e02ef8675b4c97a$export$144a039f695a9941(fallbackQuote);
        displayQuoteFn(fallbackQuote);
    }
}
function $0e02ef8675b4c97a$export$a5eb031bb7e9614e(quote, quoteText, quoteAuthor, shareQuoteBtn) {
    if (quote?.data?.[0]?.quote) {
        quoteText.textContent = `"${quote.data[0].quote}"`;
        quoteAuthor.textContent = `\u{2014} ${quote.data[0].author || "Unknown"}`;
    }
    quoteText.classList.remove("fade");
    if (shareQuoteBtn) {
        shareQuoteBtn.classList.remove("disabled");
        shareQuoteBtn.disabled = false;
    }
}
function $0e02ef8675b4c97a$var$getRandomFallbackQuote(quotes) {
    return {
        "data": [
            quotes[Math.floor(Math.random() * quotes.length)]
        ]
    };
}
function $0e02ef8675b4c97a$export$36bba7d2c0e37b0a(quoteText, quoteAuthor, shareQuoteBtn, displayQuoteFn, fetchAndDisplayQuoteFn) {
    const storedData = $0e02ef8675b4c97a$export$24aeb49d8df64e00();
    const today = new Date().toDateString();
    if (storedData && storedData.date === today) displayQuoteFn(storedData.quote, quoteText, quoteAuthor, shareQuoteBtn);
    else fetchAndDisplayQuoteFn((quote)=>displayQuoteFn(quote, quoteText, quoteAuthor, shareQuoteBtn));
}


function $937d28f882667f6b$export$34194decc8d06435(state) {
    const searchTerm = state.search.trim().toLowerCase();
    return state.tasks.filter((task)=>{
        const matchesFilter = state.filter === "all" || state.filter === "active" && !task.completed || state.filter === "completed" && task.completed;
        const matchesSearch = !searchTerm || task.title.toLowerCase().includes(searchTerm);
        return matchesFilter && matchesSearch;
    }).sort((firstTask, secondTask)=>$937d28f882667f6b$export$a8401629531bc33e(firstTask, secondTask, state.sort));
}
function $937d28f882667f6b$export$a8401629531bc33e(firstTask, secondTask, sortType) {
    switch(sortType){
        case "created-asc":
            return firstTask.createdAt - secondTask.createdAt;
        case "title-asc":
            return firstTask.title.localeCompare(secondTask.title);
        case "title-desc":
            return secondTask.title.localeCompare(firstTask.title);
        case "status":
            return Number(firstTask.completed) - Number(secondTask.completed) || secondTask.createdAt - firstTask.createdAt;
        case "created-desc":
        default:
            return secondTask.createdAt - firstTask.createdAt;
    }
}
function $937d28f882667f6b$export$3203edd9e5edd663(timestamp) {
    return new Intl.DateTimeFormat(undefined, {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit"
    }).format(timestamp);
}
function $937d28f882667f6b$export$6e96594dd218f8f1(sortValue) {
    switch(sortValue){
        case "created-asc":
            return "Oldest";
        case "title-asc":
            return "Title A-Z";
        case "title-desc":
            return "Title Z-A";
        case "status":
            return "Status";
        case "created-desc":
        default:
            return "Newest";
    }
}
function $937d28f882667f6b$export$441767afabb1c44d(tasksArray, state) {
    const existingIds = new Set(state.tasks.map((t)=>t.id));
    const existingTitles = new Set(state.tasks.map((t)=>String(t.title || "").trim().toLowerCase()));
    let added = 0;
    for (const raw of tasksArray){
        if (!raw || typeof raw !== "object") continue;
        const title = String(raw.title || "").trim();
        if (!title) continue;
        const normalizedTitle = title.toLowerCase();
        if (existingTitles.has(normalizedTitle)) continue;
        const hasId = typeof raw.id === "string" && raw.id;
        if (hasId && existingIds.has(raw.id)) continue;
        const newTask = {
            id: hasId ? raw.id : crypto.randomUUID(),
            title: title,
            completed: Boolean(raw.completed),
            createdAt: typeof raw.createdAt === "number" ? raw.createdAt : Date.now(),
            updatedAt: typeof raw.updatedAt === "number" ? raw.updatedAt : Date.now()
        };
        state.tasks.push(newTask);
        existingIds.add(newTask.id);
        existingTitles.add(normalizedTitle);
        added++;
    }
    return added;
}


function $d608d60b8f93d0b5$export$e7547304f2754201(greeting) {
    const hour = new Date().getHours();
    const period = hour < 12 ? "morning" : hour < 18 ? "afternoon" : "evening";
    greeting.textContent = `Good ${period}.`;
}
function $d608d60b8f93d0b5$export$b3890eb0ae9dca99(state, elements, taskTemplate, persistAndRenderFn, showToastFn) {
    const filteredTasks = (0, $937d28f882667f6b$export$34194decc8d06435)(state);
    const total = state.tasks.length;
    const open = state.tasks.filter((task)=>!task.completed).length;
    const done = total - open;
    elements.statTotal.textContent = String(total);
    elements.statOpen.textContent = String(open);
    elements.statDone.textContent = String(done);
    elements.taskSummary.textContent = `You have ${open} task${open === 1 ? "" : "s"} remaining for today.`;
    elements.personalProgress.textContent = `${total ? Math.round(done / total * 100) : 0}%`;
    elements.searchInput.value = state.search;
    elements.sortLabel.textContent = (0, $937d28f882667f6b$export$6e96594dd218f8f1)(state.sort);
    elements.sortMenu.querySelectorAll("[data-sort]").forEach((option)=>{
        const isActive = option.dataset.sort === state.sort;
        option.classList.toggle("active", isActive);
        option.setAttribute("aria-selected", String(isActive));
    });
    elements.taskList.innerHTML = "";
    if (!filteredTasks.length) {
        const emptyState = document.createElement("li");
        emptyState.className = "empty-state";
        emptyState.textContent = "No tasks match your current filters.";
        elements.taskList.appendChild(emptyState);
        return;
    }
    filteredTasks.forEach((task)=>{
        elements.taskList.appendChild($d608d60b8f93d0b5$export$58be7299f896be59(task, state, taskTemplate, persistAndRenderFn, showToastFn));
    });
}
function $d608d60b8f93d0b5$export$58be7299f896be59(task, state, taskTemplate, persistAndRenderFn, showToastFn) {
    const taskNode = taskTemplate.content.firstElementChild.cloneNode(true);
    const titleNode = taskNode.querySelector(".task-title");
    const metaNode = taskNode.querySelector(".task-meta");
    const toggleNode = taskNode.querySelector(".task-toggle");
    const editButton = taskNode.querySelector(".edit-btn");
    const cancelButton = taskNode.querySelector(".cancel-btn");
    const saveButton = taskNode.querySelector(".save-btn");
    const deleteButton = taskNode.querySelector(".delete-btn");
    const editInput = taskNode.querySelector(".task-edit-input");
    taskNode.dataset.id = task.id;
    taskNode.classList.toggle("completed", task.completed);
    titleNode.textContent = task.title;
    metaNode.textContent = `Updated ${(0, $937d28f882667f6b$export$3203edd9e5edd663)(task.updatedAt)}`;
    toggleNode.checked = task.completed;
    editInput.value = task.title;
    editInput.id = task.id;
    editInput.placeholder = "Edit task title";
    toggleNode.addEventListener("change", ()=>{
        task.completed = toggleNode.checked;
        task.updatedAt = Date.now();
        persistAndRenderFn(true);
    });
    editButton.addEventListener("click", ()=>{
        taskNode.classList.add("editing");
        editInput.value = task.title;
        editInput.focus();
        editInput.setSelectionRange(editInput.value.length, editInput.value.length);
    });
    saveButton.addEventListener("click", ()=>{
        $d608d60b8f93d0b5$var$commitEdit(task, editInput.value, taskNode, persistAndRenderFn, showToastFn);
    });
    editInput.addEventListener("keydown", (event)=>{
        if (event.key === "Enter") {
            event.preventDefault();
            $d608d60b8f93d0b5$var$commitEdit(task, editInput.value, taskNode, persistAndRenderFn, showToastFn);
        }
        if (event.key === "Escape") taskNode.classList.remove("editing");
    });
    cancelButton.addEventListener("click", ()=>{
        taskNode.classList.remove("editing");
    });
    deleteButton.addEventListener("click", ()=>{
        state.tasks = state.tasks.filter((existingTask)=>existingTask.id !== task.id);
        showToastFn("Task deleted successfully.", "success");
        persistAndRenderFn(true);
    });
    return taskNode;
}
function $d608d60b8f93d0b5$var$commitEdit(task, value, taskNode, persistAndRenderFn, showToastFn) {
    const nextTitle = value.trim();
    if (!nextTitle) return;
    task.title = nextTitle;
    task.updatedAt = Date.now();
    taskNode.classList.remove("editing");
    showToastFn("Task updated successfully.", "success");
    persistAndRenderFn(true);
}
function $d608d60b8f93d0b5$export$cdf8666f8011c114(state, activeButton = null) {
    document.querySelectorAll("[data-filter]").forEach((navButton)=>{
        const isActive = activeButton ? navButton === activeButton : navButton.dataset.filter === state.filter;
        navButton.classList.toggle("active", isActive);
    });
}


const $7259ed209c831d5c$var$TOAST_ICONS = {
    info: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
  </svg>`,
    success: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
  </svg>`,
    error: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
  </svg>`,
    warning: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
  </svg>`
};
function $7259ed209c831d5c$var$getToastIcon(type) {
    return $7259ed209c831d5c$var$TOAST_ICONS[type] ?? $7259ed209c831d5c$var$TOAST_ICONS.info;
}
function $7259ed209c831d5c$export$f6cef6fcf9ca4e17(message, type = "info", timeout = 10000, toasts) {
    if (!toasts) return;
    const toast = document.createElement("div");
    toast.className = `toast toast--${type}`;
    const icon = document.createElement("span");
    icon.className = "toast-icon";
    icon.innerHTML = $7259ed209c831d5c$var$getToastIcon(type);
    const body = document.createElement("div");
    body.className = "toast-body";
    body.textContent = message;
    const close = document.createElement("button");
    close.className = "toast-close";
    close.setAttribute("aria-label", "Dismiss");
    close.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
  </svg>
  `;
    close.addEventListener("click", ()=>{
        toast.remove();
    });
    toast.appendChild(icon);
    toast.appendChild(body);
    toast.appendChild(close);
    toasts.appendChild(toast);
    setTimeout(()=>{
        toast.remove();
    }, timeout);
}


function $0de955c7da0a8358$export$646a5913d87a22f5(sortToggle, sortMenu) {
    sortToggle.setAttribute("aria-expanded", "true");
    sortMenu.hidden = false;
    requestAnimationFrame(()=>{
        sortMenu.classList.add("is-open");
    });
}
function $0de955c7da0a8358$export$92659b6faa962e3e(sortToggle, sortMenu) {
    sortToggle.setAttribute("aria-expanded", "false");
    sortMenu.classList.remove("is-open");
    const handleTransitionEnd = (event)=>{
        if (event.target !== sortMenu || event.propertyName !== "opacity") return;
        sortMenu.hidden = true;
        sortMenu.removeEventListener("transitionend", handleTransitionEnd);
    };
    sortMenu.addEventListener("transitionend", handleTransitionEnd);
}
function $0de955c7da0a8358$export$5ac598f1211fe638(sortToggle, sortMenu) {
    const isExpanded = sortToggle.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
        $0de955c7da0a8358$export$92659b6faa962e3e(sortToggle, sortMenu);
        return;
    }
    $0de955c7da0a8358$export$646a5913d87a22f5(sortToggle, sortMenu);
}



function $4aa62f44a246f911$export$ccd4c2f06c6586f7(state) {
    const payload = {
        exportedAt: Date.now(),
        tasks: state.tasks
    };
    const data = JSON.stringify(payload, null, 2);
    const blob = new Blob([
        data
    ], {
        type: "application/json"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `todo-ebx-tasks-${new Date().toISOString().slice(0, 10)}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
function $4aa62f44a246f911$export$ade6d625d8828170(event, state, persistAndRenderFn, showToastFn) {
    const input = event.target;
    const file = input && input.files && input.files[0];
    if (!file) return;
    const isJson = file.type && file.type.includes("json") || file.name.toLowerCase().endsWith(".json");
    if (!isJson) {
        showToastFn("Please select a JSON file to import.", "error");
        input.value = "";
        return;
    }
    const reader = new FileReader();
    reader.onload = ()=>{
        try {
            const parsed = JSON.parse(String(reader.result));
            const tasksArray = Array.isArray(parsed) ? parsed : parsed.tasks;
            if (!Array.isArray(tasksArray)) {
                showToastFn("Invalid file format. Expected an array of tasks or an object with a 'tasks' array.", "error");
                input.value = "";
                return;
            }
            const added = (0, $937d28f882667f6b$export$441767afabb1c44d)(tasksArray, state);
            if (added > 0) {
                persistAndRenderFn(true);
                showToastFn(`Imported ${added} new task${added === 1 ? "" : "s"}.`, "success");
            } else showToastFn("No new tasks to import.", "info");
        } catch (err) {
            console.error(err);
            showToastFn("Failed to parse JSON file.", "error");
        } finally{
            input.value = "";
        }
    };
    reader.onerror = ()=>{
        showToastFn("Failed to read file.", "error");
        input.value = "";
    };
    reader.readAsText(file);
}


function $c2326ebffd673508$export$63fb7b62bbfb154e(quote, author, overlay, shareModal, showToastFn, ogDescriptionMetaElement, originalOgDescription) {
    if (!quote || !author) {
        showToastFn("No quote available to share.", "error");
        return;
    }
    // Update OG description for better sharing previews
    if (ogDescriptionMetaElement) ogDescriptionMetaElement.setAttribute("content", `${quote} ${author}`);
    overlay.classList.add("is-active");
    shareModal.classList.add("is-open");
    shareModal.querySelector(".share-quote").textContent = quote;
    shareModal.querySelector(".share-author").textContent = author;
}
function $c2326ebffd673508$export$8407a2e30970a443(quote, author, platform, overlay, shareModal, ogDescriptionMetaElement, originalOgDescription) {
    if (!quote || !author) return;
    const text = `${quote} ${author}`;
    let shareUrl = "";
    switch(platform){
        case "twitter":
            shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
            break;
        case "facebook":
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(document.location.href)}&quote=${encodeURIComponent(text)}`;
            break;
        case "linkedin":
            shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(document.location.href)}&summary=${encodeURIComponent(text)}`;
            break;
        case "whatsapp":
            shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text + " " + document.location.href)}`;
            break;
        case "bluesky":
            shareUrl = `https://bsky.app/intent/compose?text=${encodeURIComponent(text)}`;
            break;
        default:
            console.warn("Unsupported share platform:", platform);
            return;
    }
    window.open(shareUrl, "_blank", "noopener");
// closeShareModal(overlay, shareModal, ogDescriptionMetaElement, originalOgDescription);
}
function $c2326ebffd673508$export$76b1017990596240(overlay, shareModal, ogDescriptionMetaElement, originalOgDescription) {
    if (shareModal) {
        if (shareModal.classList.contains("is-open")) {
            shareModal.classList.remove("is-open");
            if (ogDescriptionMetaElement && ogDescriptionMetaElement.getAttribute("content") !== originalOgDescription) ogDescriptionMetaElement.setAttribute("content", originalOgDescription);
        }
    }
    if (overlay) {
        if (overlay.classList.contains("is-active")) overlay.classList.remove("is-active");
    }
}
function $c2326ebffd673508$export$4f3392af9e5a18dd(quote, author, showToastFn, copyQuoteBtnText) {
    if (!quote || !author) {
        showToastFn("No quote available to copy.", "error");
        return;
    }
    const text = `${quote} ${author}`;
    const copyQuoteBtn = copyQuoteBtnText.closest("button");
    const originalButtonText = copyQuoteBtnText.textContent;
    copyQuoteBtnText.textContent = "Copied!";
    copyQuoteBtn.disabled = true;
    copyQuoteBtn.classList.add("disabled");
    setTimeout(()=>{
        copyQuoteBtnText.textContent = originalButtonText;
        copyQuoteBtn.disabled = false;
        copyQuoteBtn.classList.remove("disabled");
    }, 3000);
    navigator.clipboard.writeText(text).then(()=>{
        showToastFn("Quote copied to clipboard!", "success");
    }).catch((err)=>{
        showToastFn("Failed to copy quote.", "error");
        console.error("Error copying quote to clipboard:", err);
    });
}



function $43fb5fa3bc8a4788$export$c4d12dff0a005262(dot) {
    const mouse = {
        x: 0,
        y: 0
    };
    const dotPos = {
        x: 0,
        y: 0
    };
    const ease = 0.05;
    let isMoving = false;
    function animateDot() {
        dotPos.x += (mouse.x - dotPos.x) * ease;
        dotPos.y += (mouse.y - dotPos.y) * ease;
        dot.style.transform = `translate3d(${dotPos.x}px, ${dotPos.y}px, 0) translate(-50%, -50%)`;
        requestAnimationFrame(animateDot);
    }
    window.addEventListener("mousemove", (e)=>{
        mouse.x = e.clientX;
        mouse.y = e.clientY;
        if (!isMoving) {
            dot.style.opacity = "1";
            isMoving = true;
        }
    });
    requestAnimationFrame(animateDot);
    window.addEventListener("mouseout", ()=>{
        dot.style.opacity = "0";
        isMoving = false;
    });
}


// State
let $e73bf42412feb220$var$state = (0, $fe3908612a21a758$export$ea32cbdd559da174)();
// Helper Functions
function $e73bf42412feb220$var$persistAndRender(save = true) {
    if (save) (0, $fe3908612a21a758$export$fb931cd598921492)($e73bf42412feb220$var$state);
    (0, $d608d60b8f93d0b5$export$b3890eb0ae9dca99)($e73bf42412feb220$var$state, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).taskTemplate, $e73bf42412feb220$var$persistAndRender, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts));
}
function $e73bf42412feb220$var$handleAddTask(event) {
    event.preventDefault();
    const title = (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).taskInput.value.trim();
    if (!title) return;
    $e73bf42412feb220$var$state.tasks.unshift({
        id: crypto.randomUUID(),
        title: title,
        completed: false,
        createdAt: Date.now(),
        updatedAt: Date.now()
    });
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).taskInput.value = "";
    $e73bf42412feb220$var$persistAndRender();
}
function $e73bf42412feb220$var$handleSearch(event) {
    $e73bf42412feb220$var$state.search = event.target.value;
    (0, $d608d60b8f93d0b5$export$b3890eb0ae9dca99)($e73bf42412feb220$var$state, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).taskTemplate, $e73bf42412feb220$var$persistAndRender, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts));
}
function $e73bf42412feb220$var$handleSort(sortValue) {
    $e73bf42412feb220$var$state.sort = sortValue;
    (0, $0de955c7da0a8358$export$92659b6faa962e3e)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortToggle, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu);
    $e73bf42412feb220$var$persistAndRender(false);
}
function $e73bf42412feb220$var$handleFilterChange(filter, button) {
    $e73bf42412feb220$var$state.filter = filter;
    (0, $d608d60b8f93d0b5$export$cdf8666f8011c114)($e73bf42412feb220$var$state, button);
    (0, $d608d60b8f93d0b5$export$b3890eb0ae9dca99)($e73bf42412feb220$var$state, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).taskTemplate, $e73bf42412feb220$var$persistAndRender, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts));
}
function $e73bf42412feb220$var$handleThemeToggle(event) {
    (0, $61395636afd8b3a9$export$49e16ec648d05eb2)(event.target.checked ? "dark" : "light", (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).themeToggle);
}
function $e73bf42412feb220$var$handleDocumentClick(event) {
    if (!(0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu.hidden && !event.target.closest(".sort-field")) (0, $0de955c7da0a8358$export$92659b6faa962e3e)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortToggle, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu);
    if (!(0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal.hidden && !event.target.closest(".share-modal") && !event.target.closest("#shareQuoteBtn")) (0, $c2326ebffd673508$export$76b1017990596240)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).overlay, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).ogDescriptionMeta, (0, $e5ffa7f57df22aad$export$bab7694f6b43412b));
}
function $e73bf42412feb220$var$handleDocumentKeydown(event) {
    if (event.key === "Escape") {
        (0, $0de955c7da0a8358$export$92659b6faa962e3e)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortToggle, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu);
        (0, $c2326ebffd673508$export$76b1017990596240)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).overlay, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).ogDescriptionMeta, (0, $e5ffa7f57df22aad$export$bab7694f6b43412b));
    }
    if (event.key.toLowerCase() === "q" && event.shiftKey) (0, $c2326ebffd673508$export$63fb7b62bbfb154e)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteText.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteAuthor.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).overlay, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).ogDescriptionMeta, (0, $e5ffa7f57df22aad$export$bab7694f6b43412b));
    if (event.key.toLowerCase() === "c" && event.shiftKey) (0, $c2326ebffd673508$export$4f3392af9e5a18dd)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteText.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteAuthor.textContent, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).copyQuoteBtnText);
    if (event.shiftKey && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
        const newSort = event.key === "ArrowDown" ? "created-desc" : "created-asc";
        $e73bf42412feb220$var$state.sort = newSort;
        (0, $0de955c7da0a8358$export$92659b6faa962e3e)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortToggle, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu);
        $e73bf42412feb220$var$persistAndRender(false);
    }
}
// Initialization
function $e73bf42412feb220$var$init() {
    (0, $d608d60b8f93d0b5$export$e7547304f2754201)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).greeting);
    const theme = (0, $61395636afd8b3a9$export$a1d87755f3c9500d)();
    (0, $61395636afd8b3a9$export$49e16ec648d05eb2)(theme, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).themeToggle);
    const color = (0, $61395636afd8b3a9$export$bb0fecbb07d25238)();
    (0, $61395636afd8b3a9$export$e994949bcda46cdb)(color, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).colorOptions);
    (0, $d608d60b8f93d0b5$export$cdf8666f8011c114)($e73bf42412feb220$var$state);
    (0, $0e02ef8675b4c97a$export$36bba7d2c0e37b0a)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteText, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteAuthor, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareQuoteBtn, (0, $0e02ef8675b4c97a$export$a5eb031bb7e9614e), (0, $0e02ef8675b4c97a$export$c5346dc8f6de2ad9));
    $e73bf42412feb220$var$persistAndRender();
    (0, $43fb5fa3bc8a4788$export$c4d12dff0a005262)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).dot);
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).taskForm.addEventListener("submit", $e73bf42412feb220$var$handleAddTask);
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).searchInput.addEventListener("input", $e73bf42412feb220$var$handleSearch);
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).themeToggle.addEventListener("change", $e73bf42412feb220$var$handleThemeToggle);
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).colorOptions.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            (0, $61395636afd8b3a9$export$e994949bcda46cdb)(btn.dataset.color, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).colorOptions);
        });
    });
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortToggle.addEventListener("click", ()=>(0, $0de955c7da0a8358$export$5ac598f1211fe638)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortToggle, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu));
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).sortMenu.querySelectorAll("[data-sort]").forEach((option)=>{
        option.addEventListener("click", ()=>$e73bf42412feb220$var$handleSort(option.dataset.sort));
    });
    document.addEventListener("click", $e73bf42412feb220$var$handleDocumentClick);
    document.addEventListener("keydown", $e73bf42412feb220$var$handleDocumentKeydown);
    document.querySelectorAll("[data-filter]").forEach((button)=>{
        button.addEventListener("click", ()=>$e73bf42412feb220$var$handleFilterChange(button.dataset.filter, button));
    });
    if ((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).exportBtn) (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).exportBtn.addEventListener("click", ()=>(0, $4aa62f44a246f911$export$ccd4c2f06c6586f7)($e73bf42412feb220$var$state));
    if ((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).importBtn && (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).importFileInput) {
        (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).importBtn.addEventListener("click", ()=>(0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).importFileInput.click());
        (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).importFileInput.addEventListener("change", (e)=>(0, $4aa62f44a246f911$export$ade6d625d8828170)(e, $e73bf42412feb220$var$state, $e73bf42412feb220$var$persistAndRender, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts)));
    }
    if ((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareQuoteBtn) (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareQuoteBtn.addEventListener("click", ()=>(0, $c2326ebffd673508$export$63fb7b62bbfb154e)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteText.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteAuthor.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).overlay, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).ogDescriptionMeta, (0, $e5ffa7f57df22aad$export$bab7694f6b43412b)));
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareQuoteBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>(0, $c2326ebffd673508$export$8407a2e30970a443)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteText.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteAuthor.textContent, btn.dataset.platform, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).overlay, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal));
    });
    (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).copyQuoteBtn.addEventListener("click", ()=>{
        (0, $c2326ebffd673508$export$4f3392af9e5a18dd)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteText.textContent, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).quoteAuthor.textContent, (msg, type)=>(0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(msg, type, 10000, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).toasts), (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).copyQuoteBtnText);
    });
    if ((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).closeShareModalBtn) (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).closeShareModalBtn.addEventListener("click", ()=>(0, $c2326ebffd673508$export$76b1017990596240)((0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).overlay, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).shareModal, (0, $e5ffa7f57df22aad$export$3d8c2f653ac9d0b9).ogDescriptionMeta, (0, $e5ffa7f57df22aad$export$bab7694f6b43412b)));
}
// Start the app
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $e73bf42412feb220$var$init);
else $e73bf42412feb220$var$init();


//# sourceMappingURL=vanilla-todo-crud.66f848c2.js.map
